/**
 * Fixed Navi
 *
 * 固定ナビゲーションの表示・非表示を制御
 *
 * @param {string} target 固定ナビゲーションのID
 * @param {string} trigger トリガー要素のID
 */
export function fixedNavi(target, trigger) {
	// ナビゲーションの取得
	const targetItem = document.getElementById(target);
	// トリガーの次の要素を取得
	const triggerItem = document.getElementById(trigger)?.nextElementSibling;

	if (!targetItem || !triggerItem) {
		return;
	}

	// スクロールイベントでナビゲーションを制御
	const handleScroll = () => {
		// トリガーの位置を取得
		const triggerPosition = triggerItem.getBoundingClientRect().top;
		// ナビゲーションの高さを取得
		const targetHeight = targetItem.offsetHeight + 8;

		if (triggerPosition < 0) {
			// トリガー位置が画面上部を超えた場合、ナビゲーションを固定
			targetItem.style.translate = '0 0';
		} else {
			// トリガー位置が画面内にある場合、ナビゲーションを非表示
			targetItem.style.translate = `0 -${targetHeight}px`;
		}
	};

	// 初期状態の確認
	handleScroll();

	// スクロールイベントを監視
	window.addEventListener('scroll', handleScroll);

	// リサイズ時にナビゲーションの高さを再計算
	window.addEventListener('resize', handleScroll);
}
